import React from 'react';
import './NotificationModal.css';

const NotificationModal = ({ isOpen, type = 'success', title, message, onClose, autoClose = true }) => {
  if (!isOpen) return null;

  // Auto-close después de 3 segundos si está habilitado
  React.useEffect(() => {
    if (autoClose && isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, onClose]);

  const getIcon = () => {
    const icons = {
      success: '✅',
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️'
    };
    return icons[type] || icons.success;
  };

  return (
    <div className="notification-overlay" data-testid="notification-modal">
      <div className={`notification-content ${type}`}>
        <div className="notification-header">
          <span className="notification-icon">{getIcon()}</span>
          <h3 className="notification-title">{title}</h3>
          <button onClick={onClose} className="notification-close" data-testid="close-notification">
            ✕
          </button>
        </div>
        
        <div className="notification-body">
          <p className="notification-message">{message}</p>
        </div>
        
        {!autoClose && (
          <div className="notification-actions">
            <button onClick={onClose} className="notification-btn">
              Entendido
            </button>
          </div>
        )}
        
        {autoClose && (
          <div className="notification-progress">
            <div className="progress-bar"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationModal;